export default __webpack_public_path__ + "images/referenzen/werbespot/nkl_tvc.mp4";